<script setup lang="ts">
import { storeToRefs } from 'pinia';

import useBuyNft from '~/composables/web3/useBuyNft.client';
import { CartStateEnum, useCartStore } from '~/stores/cart/useCartStore';
import { useUserStore } from '~/stores/user/useUserStore';

const cartStore = useCartStore();

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const { setShowModalNetworkDifferences, addNetworkDifferenceAnyWay, setCartState } = cartStore;

const { isShowModalNetworkDifference, cartState } = storeToRefs(cartStore);

const { buyNFT } = useBuyNft();

const attemptBuyNft = async () => {
    if (!user.value) {
        setShowModalNetworkDifferences(false);
        return userStore.showUserIsDisconnect();
    }
    setShowModalNetworkDifferences(false);
    if (!cartState.value.visible) {
        setTimeout(
            () => setCartState({
                visible: true,
                state: CartStateEnum.PAYMENT
            }),
            300
        );
    }
    await buyNFT();
};

</script>

<template>
  <Modal class="modal"
         :model-value="isShowModalNetworkDifference"
         @update:model-value="(val:boolean) => setShowModalNetworkDifferences(val)"
  >
    <h3>Add items for another chain</h3>
    <p class="mb-8">
      Adding NFTs on another chain will clear your NFTs in shopping cart now. Do you want to finish
      your purchase first?
    </p>
    <div class="display-flex justify-between">
      <Button size="size.medium"
              color="bg.mojito"
      >
        <button type="button"
                class="compact-500-accent"
                @click="addNetworkDifferenceAnyWay"
        >
          Add anyway
        </button>
      </Button>
      <Button size="size.medium"
              color="bg.mojito"
      >
        <button type="button"
                class="compact-500-accent"
                @click="attemptBuyNft()"
        >
          Finish purchase
        </button>
      </Button>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal) {
  max-width: 740px;
}
</style>
